const MyInfo = () => {
  return <div></div>;
};

export default MyInfo;
